import { useTranslation } from "react-i18next";
import {
  getProjectBasedLearning,
  useCreateProjectBasedLearning,
  useGetProjectBasedLearning,
} from "@packages/api/madlenAPI";
import {
  ProjectBasedLearningCreateRequestDto,
  ProjectBasedLearningResponseDto,
} from "@packages/api/madlenAPI.schemas";
import CreateModal, {
  CreateModalProps,
} from "../../../components/create-modal";
import ProjectBasedLearningCard from "../../../components/project-based-learning/ProjectBasedLearningCard";
import GenericToolCreationPage from "../../../components/tool_components/GenericToolCreationPage";

const CreateProjectBasedLearningView = () => {
  const { t } = useTranslation();

  const CreateModalWrapper = ({
    initialInput,
    onSubmit,
    isLoading,
    error,
  }: Partial<CreateModalProps>) => (
    <CreateModal
      title={t("projectBasedLearning.result.loading.title")}
      backPath="/content/project-based-learning"
      themeColor="coral"
      loadingTitle={t("projectBasedLearning.result.loading.title")}
      errorTitle={t("projectBasedLearning.result.error.title")}
      errorDescription={t("projectBasedLearning.result.error.description")}
      submitButtonText={t("common.generate")}
      initialInput={initialInput!}
      onSubmit={async (input) => {
        await onSubmit!(input);
      }}
      isLoading={isLoading!}
      error={error!}
    />
  );

  const ToolCardWrapper = ({
    toolData,
    onCreateAgain,
  }: {
    toolData: ProjectBasedLearningResponseDto;
    onCreateAgain: () => void;
  }) => (
    <ProjectBasedLearningCard
      project={toolData}
      onCreateAgain={onCreateAgain}
    />
  );

  return (
    <GenericToolCreationPage
      toolType="project-based-learning"
      useCreateTool={useCreateProjectBasedLearning}
      useGetTool={useGetProjectBasedLearning}
      getTool={getProjectBasedLearning}
      ToolCard={ToolCardWrapper}
      CreateModalWrapper={CreateModalWrapper}
      toolDataExtractor={(data: ProjectBasedLearningResponseDto) =>
        data?.projectProblem
      }
    />
  );
};

export default CreateProjectBasedLearningView;
